/**
 * Implant — full anatomically-inspired replacement: threaded titanium screw
 * body, tapered abutment neck and a PFM crown cap. Replaces the natural
 * crown/root of the tooth so ToothV2 should hide originals when this
 * overlay is active.
 */
import { uid } from "./_shared";

export default function Implant({ toothId }) {
  const screw = uid("imp-screw", toothId);
  const cap   = uid("imp-cap",   toothId);
  const abut  = uid("imp-abut",  toothId);

  return (
    <g style={{ pointerEvents: "none" }}>
      <defs>
        <linearGradient id={screw} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%"   stopColor="#3F4750" />
          <stop offset="35%"  stopColor="#B7BDC6" />
          <stop offset="65%"  stopColor="#8892A0" />
          <stop offset="100%" stopColor="#2A2F36" />
        </linearGradient>
        <linearGradient id={abut} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%"   stopColor="#5C6470" />
          <stop offset="50%"  stopColor="#C9CDD3" />
          <stop offset="100%" stopColor="#5C6470" />
        </linearGradient>
        <linearGradient id={cap} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor="#FFF7DC" />
          <stop offset="45%"  stopColor="#F1E5B4" />
          <stop offset="100%" stopColor="#C09B48" />
        </linearGradient>
      </defs>

      {/* Screw body — tapered rectangle with threaded ridges */}
      <path d="M 22 92 L 24 128 Q 30 130 36 128 L 38 92 Z"
            fill={`url(#${screw})`} stroke="#1B1F25" strokeWidth={0.5} />
      {[0, 1, 2, 3, 4, 5, 6].map((i) => {
        const y = 96 + i * 4.5;
        return (
          <path key={i}
                d={`M 22 ${y} L 38 ${y + 1.6} L 38 ${y + 3} L 22 ${y + 1.4} Z`}
                fill="#2A2F36" fillOpacity={0.65} />
        );
      })}
      {/* Apex point */}
      <path d="M 26 128 L 30 132 L 34 128 Z" fill="#1B1F25" />

      {/* Abutment neck */}
      <path d="M 25 82 L 24 92 L 36 92 L 35 82 Z"
            fill={`url(#${abut})`} stroke="#1B1F25" strokeWidth={0.5} />
      <rect x={25} y={80} width={10} height={3} rx={1}
            fill="#8892A0" stroke="#1B1F25" strokeWidth={0.4} />

      {/* Crown cap — porcelain fused to metal */}
      <path d="M 14 42
               C 14 30 21 22 30 22
               C 39 22 46 30 46 42
               L 46 76
               Q 30 82 14 76 Z"
            fill={`url(#${cap})`}
            stroke="#8A6A20" strokeWidth={0.9} />
      {/* Occlusal cusp shading */}
      <ellipse cx={22} cy={34} rx={4} ry={5} fill="#FFFFFF" fillOpacity={0.35} />
      <ellipse cx={38} cy={34} rx={4} ry={5} fill="#FFFFFF" fillOpacity={0.25} />
      {/* Gingival collar */}
      <path d="M 14 74 Q 30 82 46 74" fill="none"
            stroke="#8A6A20" strokeOpacity={0.7} strokeWidth={0.8} />
    </g>
  );
}
